export const paymentsStepsNumbersConfig = (step: number) => {
  return [
    {
      label: 'reviewPlan',
      isCompleted: step > 1,
      isActive: step === 1,
    },
    {
      label: 'details',
      isCompleted: step > 2,
      isActive: step === 2,
    },
    {
      label: 'billing',
      isCompleted: step > 3,
      isActive: step === 3,
    },
    {
      label: 'payment',
      isCompleted: step > 4,
      isActive: step === 4,
    },
  ]
}
